export const getScrollbarWidth = () => {
    if (import.meta.server) {
        return 0
    }

    return window.innerWidth - document.documentElement.clientWidth
}
